import styled from 'styled-components';
import { FontSizes } from '../../../common/typography/typography.styles';

export const UnverifiedPillContainer = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.6rem;
  overflow: hidden;
  padding: 0.2rem 1rem;
  border-radius: 2.4rem;
  background-color: ${({ theme }) => theme.colors.baseColors.yellow10};
  color: #997206;
  font-size: ${FontSizes.small};
  font-weight: 500;
  line-height: 1.6rem;
  letter-spacing: 0.5px;
  white-space: nowrap;

  svg {
    flex-shrink: 0;
    width: 1.4rem;
    height: 1.4rem;
  }
`;
